export const CmsDevelopersTypeDecorator = {
  url() {
    return `signup-hubspot/cms-developers`;
  },

  query() {
    return {};
  }

};